var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal-vue-d", { attrs: { name: "partner-modal", width: "804" } }, [
    _c("div", { staticClass: "partner-link-modal__tabs" }, [
      _c(
        "div",
        { staticClass: "switcher _d _partner-link" },
        _vm._l(_vm.renderTabs, function(item, index) {
          return _c("div", { key: index, staticClass: "switcher__item" }, [
            _c(
              "button",
              {
                staticClass: "switcher__link",
                class: { _active: _vm.currentType === item.type },
                on: {
                  click: function($event) {
                    return _vm.selectType(item.type)
                  }
                }
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "switcher__icon",
                    attrs: {
                      role: "img",
                      width: "24",
                      height: "24",
                      fill: item.color
                    }
                  },
                  [_c("use", { attrs: { "xlink:href": "#" + item.icon } })]
                )
              ]
            )
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "partner-link-modal__tabs-content _active" }, [
        _c(
          "div",
          { staticClass: "partner-link-content" },
          [
            _vm._l(_vm.renderForm, function(item) {
              return [
                _c(
                  "div",
                  {
                    key: "title_" + item.id,
                    staticClass: "partner-link-content__title"
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(item.title) + "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    key: "form_" + item.id,
                    staticClass: "partner-link-form _new"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "partner-link-form__input" },
                      [
                        _c("textarea-control", {
                          attrs: { rows: "3", disabled: "" },
                          model: {
                            value: item.model,
                            callback: function($$v) {
                              _vm.$set(item, "model", $$v)
                            },
                            expression: "item.model"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("partner-link-copy-btn", {
                      attrs: { "copy-value": item.model }
                    })
                  ],
                  1
                )
              ]
            })
          ],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }